import createAxios from './api'

const PATH = 'seal'

export default {
  async getSealStatus() {
    const axios = await createAxios()
    const resp = await axios.get(`${PATH}/status`)

    return resp.data
  },

  async getSealStatusDev() {
    const sealStatus = {
      enabled: true,
      secureMode: false,
      activated: true
    }
    return sealStatus
  },

  async activate(req) {
    const axios = await createAxios()
    const resp = await axios.post(`${PATH}/activate`, req)

    return resp.data
  }
}
